import { render, staticRenderFns } from "./audiences.vue?vue&type=template&id=39164b2d&scoped=true"
import script from "./audiences.vue?vue&type=script&lang=js"
export * from "./audiences.vue?vue&type=script&lang=js"
import style0 from "./audiences.vue?vue&type=style&index=0&id=39164b2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39164b2d",
  null
  
)

export default component.exports